<template>
    <div>
        <van-list v-if="list.length > 0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getListData">
            <div v-for="(subItem,index) in list" :key="index" class="card" @click="gotoDetail(subItem)">
                <div style="margin: 5px 10px 10px 10px; padding-bottom: 10px; font-weight: bold; color: #4E4E4E; font-size: 18px; border-bottom: 1px #EDEDED solid;">
                    {{subItem.applyName}}
                </div>
                <div style="display: flex; justify-content: space-between;">
                    <div>
                        <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">{{'出险人手机：' +
                            subItem.outPhone}}
                        </div>
                        <div style="margin: 0 0 10px 10px; color: #999999; font-size: 14px;">出险时间：{{subItem.outDate|dateFormat('YYYY-MM-DD')}}
                        </div>
                    </div>
                    <div style="display: flex; align-items: center;">
                        <van-icon name="arrow" color="#C8C8C8" style="margin-right: 5px;"></van-icon>
                    </div>
                </div>
            </div>
        </van-list>
        <div v-else
             style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
            <van-image :src="require('@/assets/无数据.png')" width="120px" height="94px" style="margin-top: 35%;"/>
            <span style="margin-top: 20px; color: #999999; font-size: 14px;">暂无理赔信息</span>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import { List, Cell, Icon, Image} from 'vant';

    Vue.use(List).use(Cell).use(Icon).use(Image);

    export default {
        name: "AlaimQuery",
        data() {
            return {
                list: [],
                page: 0,
                pageSize: 10,
                loading: false,
                finished: false,
            }
        },
        created() {
            this.getListData()
        },
        methods: {
            getListData() {
                if (this.finished) {
                    return;
                }
                this.page++
                this.loading = true
                this.$axios.get("/claim/list",{params: {page: this.page, pageSize:this.pageSize}}).then(res => {
                    this.loading = false
                    let data = res.data.rows
                    this.list = this.list.concat(data)
                    if (data.length < this.pageSize) {
                        this.finished = true
                    }
                }).catch(err => {
                    this.loading = false
                    console.log(err);
                })
            },
            gotoDetail(item) {
                this.$router.push({path: '/claimProgress', query: {id: item.applyId}})
            }
        }
    }
</script>

<style scoped>
    .card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px 0;
        margin: 10px;
        background-color: white;
        box-shadow: 0px 2px 4px 0px rgba(231, 231, 231, 0.5);
        border-radius: 4px;
    }

</style>
